var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "formplay_svg__animated",
    id: "formplay_svg__freepik_stories-forms",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes zoomIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}@keyframes wind{0%{transform:rotate(0deg)}25%{transform:rotate(1deg)}75%{transform:rotate(-1deg)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}svg#formplay_svg__freepik_stories-forms:not(.formplay_svg__animated) .formplay_svg__animable{opacity:0}")), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__freepik--background-complete--inject-12",
    className: "formplay_svg__animable",
    style: {
      transformOrigin: "368.665px 251.652px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "569.4px 384.585px"
    },
    id: "formplay_svg__elzzfdb0uj8pd",
    className: "formplay_svg__animable",
    fill: "#f5f5f5",
    d: "M479.27 343.02h180.26v83.13H479.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.24 422.23H483.4v-74.84h171.84zm-170.72-1.12h169.6v-72.6h-169.6z",
    style: {
      transformOrigin: "569.32px 384.81px"
    },
    id: "formplay_svg__elbwuiadfddfp",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "681.55px 384.585px"
    },
    id: "formplay_svg__elsyrt4oxr3pq",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M659.53 343.02h44.04v83.13h-44.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 370.55h170.68a.23.23 0 000-.45H484a.23.23 0 000 .45z",
    style: {
      transformOrigin: "569.34px 370.325px"
    },
    id: "formplay_svg__el4x14x2oat7j",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.88 370.33a187.09 187.09 0 000-22.59.23.23 0 00-.46 0 189.17 189.17 0 00.06 22.59.18.18 0 00.35 0z",
    style: {
      transformOrigin: "569.667px 358.989px"
    },
    id: "formplay_svg__elsyqu8kljsif",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.83 359a2.33 2.33 0 11-2.33-2.33 2.32 2.32 0 012.33 2.33z",
    style: {
      transformOrigin: "613.5px 359px"
    },
    id: "formplay_svg__elb6e6bd8kldc",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.23 359a2.33 2.33 0 11-2.32-2.33 2.32 2.32 0 012.32 2.33z",
    style: {
      transformOrigin: "523.9px 359px"
    },
    id: "formplay_svg__elockgcayqa0l",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.64 384.81a2.33 2.33 0 11-2.32-2.32 2.32 2.32 0 012.32 2.32z",
    style: {
      transformOrigin: "569.31px 384.82px"
    },
    id: "formplay_svg__elcbj49i3myb",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "502.705px 452.245px"
    },
    id: "formplay_svg__el1bboysoarxu",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M500.82 426.15l-9.28 52.19h5.22l17.11-52.19h-13.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "644.135px 452.29px"
    },
    id: "formplay_svg__elkv7xfs0o82",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M646.78 426.15l7.76 52.28h-5.22l-15.59-52.28h13.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "679.495px 452.29px"
    },
    id: "formplay_svg__elavkkj7uhoqg",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M681.62 426.15l8.8 52.28h-5.22l-16.63-52.28h13.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.49 408.34a2.33 2.33 0 11-2.33-2.33 2.32 2.32 0 012.33 2.33z",
    style: {
      transformOrigin: "569.16px 408.34px"
    },
    id: "formplay_svg__elhwgj5k3pfec",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 396.3h170.68a.23.23 0 000-.46H484a.23.23 0 000 .46z",
    style: {
      transformOrigin: "569.34px 396.07px"
    },
    id: "formplay_svg__eljg484in629l",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__eltvnwr6i0q6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "577.845px 309.4px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__elcf3mchoofwf",
    fill: "#e0e0e0",
    transform: "rotate(89.7)",
    d: "M572.3 282.15h11.09v54.5H572.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__elr5ib6cojhe"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "581.26px 334.325px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__el8r88y974sf4",
    fill: "#f5f5f5",
    transform: "rotate(89.7)",
    d: "M572.64 303.95h17.24v60.75h-17.24z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M600 342.67a64.35 64.35 0 01-.29-8.62 64.23 64.23 0 01.29-8.62 63.15 63.15 0 01.3 8.62 63.27 63.27 0 01-.3 8.62z",
    style: {
      transformOrigin: "600.005px 334.05px"
    },
    id: "formplay_svg__elpaapqkkcctm",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.52 342.67a64.35 64.35 0 01-.29-8.62 64.23 64.23 0 01.29-8.62 63.15 63.15 0 01.3 8.62 63.27 63.27 0 01-.3 8.62z",
    style: {
      transformOrigin: "602.525px 334.05px"
    },
    id: "formplay_svg__el8onevdquajp",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.07 342.67c-.17 0-.3-3.86-.3-8.62s.13-8.62.3-8.62a64.23 64.23 0 01.29 8.62 64.35 64.35 0 01-.29 8.62z",
    style: {
      transformOrigin: "560.083px 334.05px"
    },
    id: "formplay_svg__el4hztwnnx9ft",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.62 342.67a63.27 63.27 0 01-.3-8.62 63.15 63.15 0 01.3-8.62 64.23 64.23 0 01.29 8.62 64.35 64.35 0 01-.29 8.62z",
    style: {
      transformOrigin: "562.615px 334.05px"
    },
    id: "formplay_svg__ely0u3jjw4tmg",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.19 334.32c0-.16 6.13-.3 13.68-.3s13.69.14 13.69.3-6.13.3-13.69.3-13.68-.13-13.68-.3z",
    style: {
      transformOrigin: "581.875px 334.32px"
    },
    id: "formplay_svg__ellw85ny2cmab",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__elfw9hwym6jmm"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "596.975px 320.1px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__el1m0a9zden13",
    fill: "#ebebeb",
    transform: "rotate(89.7)",
    d: "M591.43 282.62h11.09v74.96h-11.09z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M623.75 324.07a3.59 3.59 0 113.54-3.59 3.57 3.57 0 01-3.54 3.59z",
    style: {
      transformOrigin: "623.7px 320.48px"
    },
    id: "formplay_svg__elx8pkgy0rv6j",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__elmwtlwz6xezd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "588.92px 320.48px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__el7hnc5i4n9ui",
    fill: "#e0e0e0",
    transform: "rotate(90)",
    d: "M587.81 295.39h2.22v50.18h-2.22z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.15 111.19s-6.37 4.86-.26 11.28a.55.55 0 00.4.18l55.73-.33s4.76-5.34.81-11.49z",
    style: {
      transformOrigin: "75.8189px 116.74px"
    },
    id: "formplay_svg__eldtz1xqsq2p",
    className: "formplay_svg__animable",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.71 116.27c0 .06-6.94.11-15.5.11s-15.5 0-15.5-.11 6.94-.12 15.5-.12 15.5.05 15.5.12z",
    style: {
      transformOrigin: "76.21px 116.265px"
    },
    id: "formplay_svg__el8zj646i1dkm",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 118.28c0 .06-3.26.11-7.29.11s-7.29 0-7.29-.11 3.27-.11 7.29-.11 7.29.05 7.29.11z",
    style: {
      transformOrigin: "75.71px 118.28px"
    },
    id: "formplay_svg__elgxgkp0wyvkd",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.41 122.14s.12-.64.29-1.67a23.53 23.53 0 00.3-4.07 22.56 22.56 0 00-.4-4.06c-.19-1-.36-1.65-.32-1.66a2 2 0 01.16.43c.09.28.2.69.32 1.2a19.71 19.71 0 01.08 8.19c-.11.51-.21.93-.3 1.21a2.62 2.62 0 01-.13.43z",
    style: {
      transformOrigin: "97.7526px 116.41px"
    },
    id: "formplay_svg__eltihwllq8lc",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.57 110.76a2 2 0 01.24.41 3.31 3.31 0 01.25.5 6.61 6.61 0 01.29.68 13.15 13.15 0 01.53 1.85 13.91 13.91 0 01.24 2.34 13.16 13.16 0 01-.21 2.35 11.22 11.22 0 01-.5 1.86c-.08.26-.19.48-.27.69s-.17.36-.24.5a2.42 2.42 0 01-.24.41s.27-.62.6-1.65a13.06 13.06 0 00.45-1.84 14 14 0 00.18-2.32 13.62 13.62 0 00-.69-4.14c-.35-1.02-.67-1.62-.63-1.64z",
    style: {
      transformOrigin: "102.343px 116.555px"
    },
    id: "formplay_svg__el8jq1boh5bck",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 122.22a1.66 1.66 0 01-.26-.38 3.59 3.59 0 01-.26-.46c-.09-.19-.21-.4-.3-.64a9.71 9.71 0 01-.54-1.76 10.54 10.54 0 01-.22-2.25 10.87 10.87 0 01.28-2.23 9.39 9.39 0 01.59-1.75c.1-.24.22-.45.31-.63a3.45 3.45 0 01.28-.46 2 2 0 01.26-.36s-.32.56-.71 1.51a12 12 0 00-.53 1.73 11.46 11.46 0 00-.25 2.2 11.71 11.71 0 00.19 2.2 9.94 9.94 0 00.49 1.74c.31.97.67 1.51.67 1.54z",
    style: {
      transformOrigin: "56.2797px 116.76px"
    },
    id: "formplay_svg__elb79g6qlgzqo",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.93 123.58a4.46 4.46 0 01-.29-.43c-.08-.14-.19-.31-.29-.52a7.15 7.15 0 01-.33-.72 11.41 11.41 0 01-.64-2 13.64 13.64 0 01-.32-2.51 13.42 13.42 0 01.21-2.53 10.66 10.66 0 01.55-2 7.78 7.78 0 01.3-.73 4.49 4.49 0 01.27-.54c.16-.29.25-.44.27-.43s-.32.65-.69 1.75a12.64 12.64 0 00-.5 2 13.91 13.91 0 00-.18 2.48 14.3 14.3 0 00.29 2.48 14 14 0 00.58 1.95c.43 1.11.84 1.72.77 1.75z",
    style: {
      transformOrigin: "49.9984px 117.375px"
    },
    id: "formplay_svg__elkhil0x6ahhp",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 139.29V150H81.34v-10.71z",
    style: {
      transformOrigin: "91.67px 144.645px"
    },
    id: "formplay_svg__elaa2knu23ftw",
    className: "formplay_svg__animable",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.33 144.73v.28a6.11 6.11 0 006.14 5.72h61.46V150H88.35a5.33 5.33 0 01-5.35-5.37 5.34 5.34 0 015.33-5.34h14.59v-1.13l-61.48.21a6.15 6.15 0 00-6.11 6.36z",
    style: {
      transformOrigin: "69.1282px 144.445px"
    },
    id: "formplay_svg__elbcfzqo6dku",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 144.77c0 .06-4.24.11-9.48.11s-9.47 0-9.47-.11 4.24-.11 9.47-.11 9.48.05 9.48.11z",
    style: {
      transformOrigin: "92.525px 144.77px"
    },
    id: "formplay_svg__elfvupkqmnio9",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.68 147.17c0 .06-4 .11-9 .11s-9-.05-9-.11 4-.11 9-.11 9 .05 9 .11z",
    style: {
      transformOrigin: "92.68px 147.17px"
    },
    id: "formplay_svg__elyw22dtb7r3h",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 149.37c0 .06-3.61.11-8.06.11s-8.06 0-8.06-.11 3.6-.11 8.06-.11 8.06.05 8.06.11z",
    style: {
      transformOrigin: "93.94px 149.37px"
    },
    id: "formplay_svg__elrwpovobt5x",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102 142.61c0 .06-4.16.11-9.28.11s-9.29-.05-9.29-.11 4.16-.11 9.29-.11 9.28.05 9.28.11z",
    style: {
      transformOrigin: "92.715px 142.61px"
    },
    id: "formplay_svg__eluqukw41vh5m",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.68 140.45c0 .06-3.7.11-8.26.11s-8.26-.05-8.26-.11 3.69-.11 8.26-.11 8.26.05 8.26.11z",
    style: {
      transformOrigin: "93.42px 140.45px"
    },
    id: "formplay_svg__elh5p2l1uwqnv",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.77 138.55a13.08 13.08 0 00-1.3 1.55 7.9 7.9 0 00.11 9.14 12.77 12.77 0 001.34 1.52 2.17 2.17 0 01-.44-.33 6.31 6.31 0 01-1-1.1 7.76 7.76 0 01-.11-9.32 6.75 6.75 0 011-1.13 2.34 2.34 0 01.4-.33z",
    style: {
      transformOrigin: "41.3947px 144.655px"
    },
    id: "formplay_svg__eli0zyhh5xdgn",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7 138.32a13.52 13.52 0 00-1.31 1.55 8.19 8.19 0 00-1.4 4.59A8.08 8.08 0 0039.5 149a12.77 12.77 0 001.34 1.52 1.85 1.85 0 01-.44-.32 7.68 7.68 0 01-1-1.1 7.78 7.78 0 01-.11-9.33 7.07 7.07 0 011-1.12 2 2 0 01.41-.33z",
    style: {
      transformOrigin: "39.3153px 144.42px"
    },
    id: "formplay_svg__elwba6107hx5",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.46 138.55a12.48 12.48 0 00-1.31 1.55 7.9 7.9 0 00.11 9.14 14 14 0 001.34 1.52 2.56 2.56 0 01-.44-.33 6.72 6.72 0 01-1-1.1A7.8 7.8 0 0181 140a7.79 7.79 0 011-1.13 2.17 2.17 0 01.46-.32z",
    style: {
      transformOrigin: "81.0649px 144.655px"
    },
    id: "formplay_svg__el5qxr5aa391u",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.38 138.32a13.52 13.52 0 00-1.31 1.55 7.9 7.9 0 00.11 9.14 14 14 0 001.34 1.52 2.12 2.12 0 01-.44-.32 7.68 7.68 0 01-1-1.1 7.82 7.82 0 01-.11-9.33 7.61 7.61 0 011-1.12 2 2 0 01.41-.34z",
    style: {
      transformOrigin: "79.0002px 144.425px"
    },
    id: "formplay_svg__el4djm92sev3l",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.77 146.22l-.06-4.33a3 3 0 00-.15-1.12 1 1 0 00-.82-.69 1.65 1.65 0 00-1.77.83 4.19 4.19 0 00-.43 2.13 30.3 30.3 0 00.17 3.43 3.79 3.79 0 00.4 1.56 1.45 1.45 0 001.32.8 1.47 1.47 0 001.16-1 4.29 4.29 0 00.18-1.61z",
    style: {
      transformOrigin: "48.1575px 144.439px"
    },
    id: "formplay_svg__el6hp2tk8raq5",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.64 145c0 .06-4.44.11-9.92.11s-9.93-.05-9.93-.11 4.45-.11 9.93-.11 9.92.03 9.92.11z",
    style: {
      transformOrigin: "63.715px 145px"
    },
    id: "formplay_svg__el8xixe7phlzp",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "48.385px 133.065px"
    },
    id: "formplay_svg__el6mhv2d34d2l",
    className: "formplay_svg__animable",
    fill: "#f5f5f5",
    d: "M45.65 138.12l-.11-10.11h5.5l.19 10.11h-5.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.72 129.81a15.12 15.12 0 01-2.56.11 15.12 15.12 0 01-2.56-.11 15.12 15.12 0 012.56-.11 15.12 15.12 0 012.56.11z",
    style: {
      transformOrigin: "48.16px 129.81px"
    },
    id: "formplay_svg__eld9rcezhohgg",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.72 131.37a15.12 15.12 0 01-2.56.11 15.12 15.12 0 01-2.56-.11 15.12 15.12 0 012.56-.11 15.12 15.12 0 012.56.11z",
    style: {
      transformOrigin: "48.16px 131.37px"
    },
    id: "formplay_svg__elcbbw247j64m",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.72 132.93a15.12 15.12 0 01-2.56.11 15.12 15.12 0 01-2.56-.11 15.12 15.12 0 012.56-.11 15.12 15.12 0 012.56.11z",
    style: {
      transformOrigin: "48.16px 132.93px"
    },
    id: "formplay_svg__eln83zauxb28",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.72 134.49a15.12 15.12 0 01-2.56.11 15.12 15.12 0 01-2.56-.11 15.12 15.12 0 012.56-.11 15.12 15.12 0 012.56.11z",
    style: {
      transformOrigin: "48.16px 134.49px"
    },
    id: "formplay_svg__elrq2qrco20x",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.72 136.05a15.12 15.12 0 01-2.56.11 15.12 15.12 0 01-2.56-.11 15.12 15.12 0 012.56-.11 15.12 15.12 0 012.56.11z",
    style: {
      transformOrigin: "48.16px 136.05px"
    },
    id: "formplay_svg__eln3kd9ylqmu",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.25 127.74h61a28.87 28.87 0 010 10.93H45.51v-.74h3.71a1.75 1.75 0 001.78-1.75v-6.05a1.75 1.75 0 00-1.75-1.75h-4z",
    style: {
      transformOrigin: "76.011px 133.205px"
    },
    id: "formplay_svg__elkadxeyoi0ha",
    className: "formplay_svg__animable",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.67 133.21h1a.2.2 0 01.11 0 .2.2 0 01.11.19.15.15 0 010 .07l-.06.26a3 3 0 01-.64 1.15 1.2 1.2 0 01-.87.45h-.12a1 1 0 01-.69-.5 2.22 2.22 0 01-.31-1.23 3.37 3.37 0 01.12-.87 2.88 2.88 0 01.61-1.18 1.22 1.22 0 01.91-.48.85.85 0 01.39.08 1.25 1.25 0 01.59.75.17.17 0 010 .1.22.22 0 01-.22.22h-.07a.19.19 0 01-.14-.13.9.9 0 00-.12-.24.58.58 0 00-.49-.29.61.61 0 00-.34.12 1.76 1.76 0 00-.55.8 3 3 0 00-.24 1.15 2.16 2.16 0 00.17.9.61.61 0 00.53.4.7.7 0 00.49-.3 2.66 2.66 0 00.53-.94h-.73c-.16 0-.24-.11-.25-.25s0 0 0-.07a.22.22 0 01.28-.16z",
    style: {
      transformOrigin: "59.5461px 133.2px"
    },
    id: "formplay_svg__ell234udhvruj",
    className: "formplay_svg__animable",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.13 131.23v.07c0 .15.28 1.41.71 3.78a.13.13 0 010 .06.26.26 0 010 .11.2.2 0 01-.18.11.2.2 0 01-.17-.15l-.26-1.21H62l-.6 1.26a.26.26 0 01-.19.11.19.19 0 01-.12 0 .21.21 0 01-.1-.18.25.25 0 010-.07c0-.08.1-.22.18-.41.88-1.91 1.4-3 1.58-3.39a.23.23 0 01.41 0zm-.27.84l-.68 1.43h1z",
    style: {
      transformOrigin: "62.4167px 133.287px"
    },
    id: "formplay_svg__el07fjv7sfsipo",
    className: "formplay_svg__animable",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.53 135.36h-1.84a.19.19 0 01-.12 0s-.08-.11-.1-.23c0-.07.17-1.33.51-3.76a.19.19 0 010-.08.2.2 0 01.2-.14.19.19 0 01.1 0 .2.2 0 01.11.19c0 .17-.06.51-.12 1q-.32 2.41-.33 2.55h1.56a.25.25 0 01.12 0 .21.21 0 01.14.2v.08a.27.27 0 01-.23.19z",
    style: {
      transformOrigin: "65.615px 133.257px"
    },
    id: "formplay_svg__el39a42jgsmyz",
    className: "formplay_svg__animable",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 131.23v.07q.06.22.72 3.78a.13.13 0 010 .06.26.26 0 010 .11.2.2 0 01-.18.11.23.23 0 01-.17-.15l-.23-1.21h-1.25l-.6 1.26a.26.26 0 01-.19.11.16.16 0 01-.12 0 .19.19 0 01-.1-.18.2.2 0 010-.07l.19-.41c.88-1.91 1.4-3 1.57-3.39a.23.23 0 01.21-.15.22.22 0 01.15.06zm-.27.84l-.68 1.43h1z",
    style: {
      transformOrigin: "68.3014px 133.276px"
    },
    id: "formplay_svg__elh1tvhikrzm8",
    className: "formplay_svg__animable",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 133.4c.15.39.26.7.33.92.19.52.29.8.29.83a.17.17 0 010 .11.19.19 0 01-.18.1q-.12 0-.18-.15v-.09c-.1-.23-.26-.66-.49-1.3l-1 1.42a.24.24 0 01-.19.12h-.12a.19.19 0 01-.1-.18v-.05a.69.69 0 01.11-.18c.35-.45.74-1 1.16-1.61 0-.12-.09-.24-.13-.35-.39-1-.59-1.59-.59-1.62a.2.2 0 010-.11.18.18 0 01.18-.11.21.21 0 01.2.12l.62 1.65 1.09-1.69a.26.26 0 01.2-.11.17.17 0 01.1 0 .2.2 0 01.11.19.19.19 0 010 .1z",
    style: {
      transformOrigin: "71.8881px 133.236px"
    },
    id: "formplay_svg__el8i5xsl76p85",
    className: "formplay_svg__animable",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52 131.13a.17.17 0 01.1 0 .21.21 0 01.12.19c-.3 2.37-.47 3.66-.5 3.85a2.38 2.38 0 01-.39 1 1.44 1.44 0 01-1.22.6 1.34 1.34 0 01-.59-.16 1.31 1.31 0 01-.65-.56.22.22 0 010-.11.22.22 0 01.22-.22.19.19 0 01.16.09 1.2 1.2 0 00.94.54 1 1 0 00.73-.37 2 2 0 00.41-1.16 1.06 1.06 0 01-.27.29 1.13 1.13 0 01-.66.21h-.12a1 1 0 01-.7-.51 2.19 2.19 0 01-.31-1.22v-.69c0-.37.12-.9.25-1.58a.14.14 0 010-.07.2.2 0 01.2-.15.19.19 0 01.1 0 .18.18 0 01.11.18 7.38 7.38 0 01-.1.84 12.68 12.68 0 00-.14 1.28 2.53 2.53 0 00.16 1c.13.3.31.45.55.45H75a1 1 0 00.55-.44 2.65 2.65 0 00.45-1l.28-2.1v-.09a.2.2 0 01.24-.09z",
    style: {
      transformOrigin: "75.0615px 133.932px"
    },
    id: "formplay_svg__elyj9q9evrb5b",
    className: "formplay_svg__animable",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 138.81c-.07 0-.12-2.51-.12-5.6s0-5.61.12-5.61.11 2.51.11 5.61-.11 5.6-.11 5.6z",
    style: {
      transformOrigin: "103.995px 133.205px"
    },
    id: "formplay_svg__elz41vqlldn5d",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 138.81c-.06 0-.12-2.51-.12-5.6s.06-5.61.12-5.61.11 2.51.11 5.61-.01 5.6-.11 5.6z",
    style: {
      transformOrigin: "53.995px 133.205px"
    },
    id: "formplay_svg__elimd06xl08u",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 138.81c-.07 0-.12-2.51-.12-5.6s0-5.61.12-5.61.11 2.51.11 5.61-.03 5.6-.11 5.6z",
    style: {
      transformOrigin: "104.995px 133.205px"
    },
    id: "formplay_svg__elpe92jmqle1b",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 138.81c-.07 0-.12-2.51-.12-5.6s0-5.61.12-5.61.11 2.51.11 5.61-.01 5.6-.11 5.6z",
    style: {
      transformOrigin: "52.9951px 133.205px"
    },
    id: "formplay_svg__elqoscbj7g9m",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.16 129.45l6.44 5.2.06.05h-.07l-.86.23-5.44 1.43-4.93-2.1-1.4-.59-.37-.16-.09-.05h.1l.37.15 1.4.58 5 2.07 5.44-1.43.86-.23v.07l-6.43-5.22",
    style: {
      transformOrigin: "89.085px 132.905px"
    },
    id: "formplay_svg__el1vxt40y1dj3",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "95.205px 134.51px"
    },
    id: "formplay_svg__elaq5z2f82ztt",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M95.01 133.82l.35.33.47-.1-.2.44.24.41-.48-.06-.32.36-.09-.47-.44-.2.42-.23.05-.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "88.99px 136.315px"
    },
    id: "formplay_svg__elodipohrsb8",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M88.83 135.87l.24.2.3-.08-.12.29.18.25-.32-.02-.19.25-.08-.3-.29-.11.27-.17.01-.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "82.535px 133.335px"
    },
    id: "formplay_svg__elmqcm98q6xvf",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M82 133.07l.38.02.24-.3.09.37.36.13-.32.21-.02.38-.29-.24-.37.1.14-.35-.21-.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "98.44px 129.795px"
    },
    id: "formplay_svg__elnrinnvw70m",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M97.9 129.53l.38.02.24-.3.1.37.36.14-.33.2-.01.38-.3-.24-.37.11.15-.36-.22-.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "89.19px 129.45px"
    },
    id: "formplay_svg__elf0sq6e2b4",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M88.85 129.28l.24.01.15-.19.06.24.23.08-.2.13-.01.25-.19-.16-.24.07.09-.23-.13-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.44 129.8s-2.09-.05-4.66-.16-4.65-.22-4.65-.24 2.08 0 4.66.15 4.65.22 4.65.25z",
    style: {
      transformOrigin: "93.785px 129.597px"
    },
    id: "formplay_svg__elgovu2jq5bk",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.78 127.65H38.92c-.81-1.84-1-3.59 0-5.15h61.86a6 6 0 010 5.15z",
    style: {
      transformOrigin: "69.8px 125.075px"
    },
    id: "formplay_svg__elxcpe3da6mnf",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "68.485px 124.905px"
    },
    id: "formplay_svg__ele0fa4iop3no",
    className: "formplay_svg__animable",
    fill: "#ebebeb",
    d: "M51.73 123.97h33.51v1.87H51.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3 127.68a1.92 1.92 0 01-.49-.63 4.35 4.35 0 01-.56-1.82 4.45 4.45 0 01.23-1.9 1.92 1.92 0 01.37-.7 4.14 4.14 0 01-.22.75 5.53 5.53 0 00-.16 1.83A5.3 5.3 0 0041 127a6.13 6.13 0 01.3.68z",
    style: {
      transformOrigin: "40.7647px 125.155px"
    },
    id: "formplay_svg__el1wonwg8dzjp",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.64 127.68a1.92 1.92 0 01-.49-.63 4.49 4.49 0 01-.57-1.82 4.6 4.6 0 01.24-1.9 1.92 1.92 0 01.37-.7 4.14 4.14 0 01-.22.75 5.53 5.53 0 00-.16 1.83 5.07 5.07 0 00.48 1.77 6.13 6.13 0 01.35.7z",
    style: {
      transformOrigin: "42.1019px 125.155px"
    },
    id: "formplay_svg__el9ikzlk8zqwd",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.28 127.56a10.47 10.47 0 00.43-2.52 10.67 10.67 0 00-.4-2.52 4.45 4.45 0 01.63 2.52 4.54 4.54 0 01-.66 2.52z",
    style: {
      transformOrigin: "98.6129px 125.04px"
    },
    id: "formplay_svg__elspx8ezo078q",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.13 127.54c-.07 0 .19-1.1.18-2.46s-.26-2.45-.19-2.47a6.09 6.09 0 01.42 2.47 5.92 5.92 0 01-.41 2.46z",
    style: {
      transformOrigin: "97.3271px 125.075px"
    },
    id: "formplay_svg__el2iyb9t7vv2i",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__elgd3x8zrdq6k"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "140.995px 62.69px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__eld09zyzam6uj",
    fill: "#ebebeb",
    transform: "rotate(-.31)",
    d: "M129.98 51.01h22.03v23.36h-22.03z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__elvz3twrnl1pe"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "162.915px 62.57px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__elotdk1kkihf",
    fill: "#f5f5f5",
    transform: "rotate(-.573)",
    d: "M151.9 50.89h22.03v23.36H151.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130 57.52q22 .18 44-.2a.24.24 0 000-.47c-14.63-.08-29.31 0-43.94.27a.2.2 0 000 .4z",
    style: {
      transformOrigin: "152.026px 57.1992px"
    },
    id: "formplay_svg__eltqwpmq5erca",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__elm19gvb5tj5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "136.24px 83.55px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__elufin6uxmdm",
    fill: "#ebebeb",
    transform: "rotate(-.31)",
    d: "M116.23 74.03h40.02v19.04h-40.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__eliuze8v2g4uq"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "176.07px 83.34px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__el771uj805z9q",
    fill: "#f5f5f5",
    transform: "rotate(-.31)",
    d: "M156.06 73.82h40.02v19.04h-40.02z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.21 79.43c26.58.31 53.26 0 79.84-.39a.24.24 0 000-.47c-26.58-.14-53.26-.12-79.84.46a.2.2 0 000 .4z",
    style: {
      transformOrigin: "156.126px 79.0271px"
    },
    id: "formplay_svg__elymyxbem7xqn",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__el5y7h6mbh3yv"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "100.12px 191.32px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__el3jjv8heshxi",
    fill: "#ebebeb",
    transform: "rotate(-.31)",
    d: "M80.11 181.8h40.02v19.04H80.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__el9e5f0amlr97"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "139.95px 191.11px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__elloqq65kb1k",
    fill: "#f5f5f5",
    transform: "rotate(-.31)",
    d: "M119.94 181.59h40.02v19.04h-40.02z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.09 187.2c26.58.3 53.26 0 79.84-.39a.24.24 0 000-.47c-26.59-.14-53.26-.12-79.84.46a.2.2 0 000 .4z",
    style: {
      transformOrigin: "120.006px 186.795px"
    },
    id: "formplay_svg__elppgzynms74",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__elm7tkejywjxb"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "61.455px 68.145px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__el7z1841qwobs",
    fill: "#e0e0e0",
    transform: "rotate(-.31)",
    d: "M56.41 43.03H66.5v50.23H56.41z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__elwl4m5kd3tbh"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "71.355px 58.84px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__eley3u4erbvdj",
    fill: "#ebebeb",
    transform: "rotate(-.31)",
    d: "M66.31 24.3H76.4v69.08H66.31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__elsyg2pti1fbo"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "84.295px 65.16px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__elfhep0yxtp8o",
    fill: "#f5f5f5",
    transform: "rotate(-.31)",
    d: "M76.45 37.17h15.69v55.98H76.45z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.88 47.92a57 57 0 01-7.84.27 57 57 0 01-7.84-.27 56 56 0 017.8-.28 56 56 0 017.88.28z",
    style: {
      transformOrigin: "84.04px 47.9148px"
    },
    id: "formplay_svg__el3mguy6mgde2",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88 45.56a56 56 0 01-7.84.28 56 56 0 01-7.84-.28 57 57 0 017.8-.27 57 57 0 017.88.27z",
    style: {
      transformOrigin: "84.04px 45.5641px"
    },
    id: "formplay_svg__el4g1a35m2zxa",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88 84.69A57 57 0 0184 85a57 57 0 01-7.84-.27 57 57 0 017.84-.31 57 57 0 017.88.27z",
    style: {
      transformOrigin: "84.02px 84.7095px"
    },
    id: "formplay_svg__el39bli8rbpae",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.88 82.34a57 57 0 01-7.84.27 57 57 0 01-7.84-.27 57 57 0 017.8-.27 57 57 0 017.88.27z",
    style: {
      transformOrigin: "84.04px 82.3395px"
    },
    id: "formplay_svg__el1symk5s4mwj",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.29 77.21c-.15 0-.27-5.65-.27-12.62S84.14 52 84.29 52s.27 5.65.27 12.61-.12 12.6-.27 12.6z",
    style: {
      transformOrigin: "84.29px 64.605px"
    },
    id: "formplay_svg__el3um2extoe75",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "100.585px 72.01px"
    },
    id: "formplay_svg__elq5g49z1njk9",
    className: "formplay_svg__animable",
    fill: "#ebebeb",
    d: "M92.05 50.88h17.07v42.26H92.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.92 36.07A2.9 2.9 0 1171 33.16a2.9 2.9 0 012.92 2.91z",
    style: {
      transformOrigin: "71.02px 36.0599px"
    },
    id: "formplay_svg__elm1bxhepa1b",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "71.015px 64.59px"
    },
    id: "formplay_svg__elx0sc1nl7ds",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M70.12 44.04h1.79v41.1h-1.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "117.01px 154.12px"
    },
    id: "formplay_svg__el1klvn5dhsnl",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M28.15 151.08h177.72v6.08H28.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "117.01px 96.45px"
    },
    id: "formplay_svg__elkhummi7cct",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M28.15 93.41h177.72v6.08H28.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "135.145px 203.85px"
    },
    id: "formplay_svg__el96e445anv18",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M64.42 200.98h141.45v5.74H64.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "113.62px 126.985px"
    },
    id: "formplay_svg__el1a6xhohymr7",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M110.23 98.3h6.78v57.37h-6.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "67.85px 178.89px"
    },
    id: "formplay_svg__elsgvnzwkr63e",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M64.46 151.08h6.78v55.62h-6.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.94 125l-4.17 6s9.38 2.61 9.38 10.94-5.73 9.89-12 9.89-12.24-1.82-12-10.15 8.07-11.46 8.07-11.46l-3.9-5.2z",
    style: {
      transformOrigin: "144.147px 138.415px"
    },
    id: "formplay_svg__elredi0hrud7d",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "705.665px 124.55px"
    },
    id: "formplay_svg__elnsogrbv1nas",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M702.15 49.01h7.03v151.08h-7.03z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.22,
    y: 50.17,
    width: 100.86,
    height: 150.12,
    rx: 0.1,
    style: {
      transformOrigin: "650.65px 125.23px"
    },
    id: "formplay_svg__eltam1pbvf0hh",
    className: "formplay_svg__animable",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.15 201.46h-103a.09.09 0 01-.1-.1V49.11a.09.09 0 01.1-.1h103a.09.09 0 01.1.1v152.25a.09.09 0 01-.1.1zm-100.66-2.34h98.33a.1.1 0 00.1-.1V51.44a.11.11 0 00-.1-.1h-98.33a.11.11 0 00-.1.1V199a.1.1 0 00.1.12z",
    style: {
      transformOrigin: "650.65px 125.235px"
    },
    id: "formplay_svg__elrofp9md7kfn",
    className: "formplay_svg__animable",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.38,
    y: 59.44,
    width: 80.73,
    height: 131.5,
    rx: 0.1,
    style: {
      transformOrigin: "650.745px 125.19px"
    },
    id: "formplay_svg__elaj0r3kr313",
    className: "formplay_svg__animable",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.99,
    y: 96.72,
    width: 45.33,
    height: 53.13,
    rx: 0.06,
    style: {
      transformOrigin: "650.655px 123.285px"
    },
    id: "formplay_svg__elquf5a6kp3zs",
    className: "formplay_svg__animable",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.73 143.34c.06.17-2.18 1.15-6.43.65a15.71 15.71 0 01-7.24-2.89 14.7 14.7 0 01-5.62-8.84 12.71 12.71 0 014.3-12.09 11.47 11.47 0 013.26-1.91 8.81 8.81 0 014.08-.47 7.11 7.11 0 014.07 1.79 5.29 5.29 0 011.61 4.74 7.7 7.7 0 01-2.24 4.08 14.73 14.73 0 01-3.41 2.52 18.72 18.72 0 01-8.15 2.32 16.17 16.17 0 01-8.68-2 15.82 15.82 0 01-6.39-6.62 13.48 13.48 0 01-1.14-9.28 13.76 13.76 0 014.88-7.64 12.2 12.2 0 014.1-2.07 10.16 10.16 0 014.62-.14 7.5 7.5 0 014.18 2.36 6.94 6.94 0 011.65 4.47 8.59 8.59 0 01-1.1 4.27 11.26 11.26 0 01-2.58 3.1 17.41 17.41 0 01-6.42 3.42 16.45 16.45 0 01-6.76.52 14 14 0 01-5.88-2.25 12.73 12.73 0 01-5.61-8.9 10.67 10.67 0 012.08-7.62 9 9 0 013.85-3.08c1-.4 1.66-.39 1.68-.29s-.48.38-1.33 1a10 10 0 00-3 3.21 9.54 9.54 0 00-1.22 6.52 10.7 10.7 0 005 7 12.33 12.33 0 0010.3 1 14.4 14.4 0 005.15-2.92 6.29 6.29 0 002.41-4.83 3.47 3.47 0 00-3.1-3.42 6.61 6.61 0 00-3 .13 8.57 8.57 0 00-2.8 1.47 10.22 10.22 0 00-3.53 5.62 9.84 9.84 0 00.87 6.73 12.11 12.11 0 004.91 5 12.63 12.63 0 006.71 1.57 15.27 15.27 0 006.59-1.81 11.56 11.56 0 002.64-1.85 4.55 4.55 0 001.33-2.18 1.87 1.87 0 00-.54-1.75 3.9 3.9 0 00-2.18-1 5.55 5.55 0 00-2.57.22 8.31 8.31 0 00-2.39 1.31 10 10 0 00-3.65 9.25 12.71 12.71 0 004.32 7.65 15.19 15.19 0 006.21 3.1c3.83.95 6.13.49 6.16.83z",
    style: {
      transformOrigin: "649.247px 122.781px"
    },
    id: "formplay_svg__elpvmf1egsexc",
    className: "formplay_svg__animable",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "230.385px 466.69px"
    },
    id: "formplay_svg__el7gudtfhilgw",
    className: "formplay_svg__animable",
    fill: "#f5f5f5",
    d: "M192.43 454.35v24.68h75.91v-24.68h-75.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "230.125px 450.9px"
    },
    id: "formplay_svg__elzsyqt23567",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M189.25 447.45v6.9H271v-6.9h-81.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "249.765px 463.24px"
    },
    id: "formplay_svg__elfrj8xeu1afs",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M230.12 479.03h38.22v-24.68H271v-6.9h-42.47v6.26l1.59 25.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "210.745px 460.19px"
    },
    id: "formplay_svg__elr6ba39idu9",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M203.05 458.33h15.39v3.72h-15.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "210.955px 470.615px"
    },
    id: "formplay_svg__elfzpja4cw8du",
    className: "formplay_svg__animable",
    fill: "#fff",
    d: "M201.07 466.69h19.77v7.85h-19.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "248.055px 435.14px"
    },
    id: "formplay_svg__elynvmij9gr9s",
    className: "formplay_svg__animable",
    fill: "#f5f5f5",
    d: "M210.1 422.8v24.68h75.91V422.8H210.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "247.785px 419.35px"
    },
    id: "formplay_svg__eln2iz8e4rui",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M206.91 415.9v6.9h81.75v-6.9h-81.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "267.425px 431.69px"
    },
    id: "formplay_svg__el6rg9xrb86u",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M247.79 447.48h38.22V422.8h2.65v-6.9h-42.47v6.26l1.6 25.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "228.405px 428.64px"
    },
    id: "formplay_svg__elqtoc6tqe2af",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M220.71 426.78h15.39v3.72h-15.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "228.615px 439.065px"
    },
    id: "formplay_svg__elc5ziziyiez7",
    className: "formplay_svg__animable",
    fill: "#fff",
    d: "M218.73 435.14h19.77v7.85h-19.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "93.315px 465.8px"
    },
    id: "formplay_svg__el6tbacmgszur",
    className: "formplay_svg__animable",
    fill: "#f5f5f5",
    d: "M55.36 453.46v24.68h75.91v-24.68H55.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "93.055px 450.01px"
    },
    id: "formplay_svg__eliacopn33vc",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M52.18 446.56v6.9h81.75v-6.9H52.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "112.695px 462.35px"
    },
    id: "formplay_svg__ela5vl2jcyfuw",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M93.05 478.14h38.22v-24.68h2.66v-6.9H91.46v6.26l1.59 25.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "73.675px 459.3px"
    },
    id: "formplay_svg__elh0tvxj0tffa",
    className: "formplay_svg__animable",
    fill: "#e0e0e0",
    d: "M65.98 457.44h15.39v3.72H65.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "73.885px 469.725px"
    },
    id: "formplay_svg__elsojywrxfuks",
    className: "formplay_svg__animable",
    fill: "#fff",
    d: "M64 465.8h19.77v7.85H64z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__freepik--Floor--inject-12",
    className: "formplay_svg__animable",
    style: {
      transformOrigin: "380px 478.245px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.66 478.23c0 .14-133.28.26-297.65.26s-297.67-.12-297.67-.26S215.59 478 380 478s297.66.08 297.66.23z",
    style: {
      transformOrigin: "380px 478.245px"
    },
    id: "formplay_svg__elw6ldezvq3gg",
    className: "formplay_svg__animable",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__freepik--Plant--inject-12",
    className: "formplay_svg__animable",
    style: {
      transformOrigin: "129.698px 378.601px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown,1.5s Infinite linear floating",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "130.79px 421.55px"
    },
    id: "formplay_svg__elahc1sf5e06b",
    className: "formplay_svg__animable",
    fill: "#263238",
    d: "M94.04 416.5h73.5v10.1h-73.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.67 426.72H93.91v-10.35h73.76zm-73.51-.25h73.25v-9.85H94.16z",
    style: {
      transformOrigin: "130.79px 421.545px"
    },
    id: "formplay_svg__el8qgpsdeumtf",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "130.83px 449.33px"
    },
    id: "formplay_svg__elcxa65jaq6ja",
    className: "formplay_svg__animable",
    fill: "#263238",
    d: "M100.85 423.23l10.58 52.2h39.15l10.23-48.83-59.96-3.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "130.83px 474.37px"
    },
    id: "formplay_svg__el5u34y7ecbdq",
    className: "formplay_svg__animable",
    fill: "#455a64",
    d: "M100.85 470.49l5.65 7.76h47.58l6.73-7.76h-59.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 424.76c-.15 0-.33-24.18-.42-54s0-54 .11-54 .33 24.18.42 54 .06 54-.11 54z",
    style: {
      transformOrigin: "127.851px 370.76px"
    },
    id: "formplay_svg__elxjbybb32trp",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.4 364.24a2.12 2.12 0 01-.2.57c-.17.41-.38.93-.65 1.56l-.48 1.13-.49 1.37-.57 1.58c-.19.55-.35 1.16-.54 1.79a74.79 74.79 0 00-2.06 9 110.44 110.44 0 00-1.13 11.26 150.38 150.38 0 00.58 20.55c.23 2.63.47 4.75.65 6.21.07.69.13 1.25.18 1.69a2.28 2.28 0 010 .6 2.65 2.65 0 01-.13-.58c-.08-.44-.17-1-.29-1.68-.23-1.46-.53-3.57-.81-6.2a135.18 135.18 0 01-.74-20.62 102.91 102.91 0 011.19-11.31 66.7 66.7 0 012.18-9c.2-.63.37-1.23.58-1.79s.41-1.08.61-1.57l.53-1.37c.18-.41.36-.78.52-1.11.31-.62.55-1.13.75-1.53a4.09 4.09 0 01.32-.55z",
    style: {
      transformOrigin: "141.005px 392.895px"
    },
    id: "formplay_svg__eliqc4qz0vqt9",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.52 344.69a4.29 4.29 0 01-.23.79l-.77 2.25c-.17.49-.35 1-.56 1.62s-.38 1.26-.59 2c-.43 1.4-.93 3-1.37 4.77-.24.9-.48 1.83-.74 2.8l-.69 3.06c-.51 2.1-.88 4.39-1.35 6.78-.81 4.8-1.53 10.11-2 15.71s-.67 11-.74 15.83 0 9.26.25 12.95c.06 1.84.18 3.5.28 5s.17 2.72.27 3.75.13 1.78.18 2.37a4.74 4.74 0 010 .83 6.91 6.91 0 01-.13-.82c-.07-.59-.16-1.37-.28-2.36s-.24-2.28-.36-3.75-.26-3.12-.35-5c-.25-3.68-.35-8.08-.36-13s.23-10.26.7-15.88 1.22-10.94 2.06-15.75c.49-2.39.88-4.68 1.41-6.79.25-1 .49-2.08.72-3.06s.53-1.9.77-2.79c.47-1.79 1-3.38 1.45-4.77l.64-2c.22-.58.42-1.12.6-1.61.36-.92.65-1.66.86-2.21a5.24 5.24 0 01.33-.72z",
    style: {
      transformOrigin: "137.75px 384.945px"
    },
    id: "formplay_svg__elxbz3xxwfizf",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.38 429a1.36 1.36 0 010-.29c0-.21 0-.49-.07-.83 0-.77-.13-1.84-.22-3.2-.17-2.82-.43-6.84-.73-11.78-.64-9.94-1.57-23.68-3.24-38.79-.85-7.55-1.85-14.72-2.88-21.23-.54-3.24-1-6.33-1.6-9.21s-1.08-5.55-1.59-8-1-4.63-1.46-6.56-.83-3.58-1.18-4.93-.58-2.37-.76-3.12c-.08-.33-.14-.6-.19-.81a.9.9 0 010-.29 2.16 2.16 0 01.09.27c.07.21.14.48.24.8.21.75.49 1.78.86 3.1s.81 3 1.27 4.91 1 4.11 1.53 6.56 1.12 5.1 1.65 8 1.1 6 1.66 9.21a436.47 436.47 0 012.92 21.25c1.68 15.13 2.54 28.88 3.08 38.83.28 5 .46 9 .58 11.79 0 1.36.09 2.43.11 3.21v.83a1.29 1.29 0 01-.07.28z",
    style: {
      transformOrigin: "116.449px 374.48px"
    },
    id: "formplay_svg__el2ne7qjohhw7",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.43 328.37c-.32-3.43-3.78-6-7.22-6.05s-6.65 2-8.75 4.75a27.36 27.36 0 00-4.22 9.36c-2.31 8.07-3.58 16.55-2.59 24.88S109 377.86 115 383.75c1 1 2.23 1.92 3.56 1.63a4.31 4.31 0 001.89-1.16 55.69 55.69 0 0018.07-42.35c-.09-3.17-.51-6.47-2.26-9.11s-5.85-5.45-8.84-4.39",
    style: {
      transformOrigin: "121.423px 353.877px"
    },
    id: "formplay_svg__el5sjutah81s7",
    className: "formplay_svg__animable",
    fill: "#fcbd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.74 300.93l-4.85 8.78c-.11.2-.26.43-.49.45s-.45-.22-.59-.43L83 290.06l3-1.67z",
    style: {
      transformOrigin: "92.37px 299.276px"
    },
    id: "formplay_svg__el7ktzthdrzup",
    className: "formplay_svg__animable",
    fill: "#fcbd00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "formplay_svg__el5xe862odvcy"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "92.37px 299.276px"
    },
    className: "formplay_svg__animable",
    id: "formplay_svg__elu1juw7jli98",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.74 300.93l-4.85 8.78c-.11.2-.26.43-.49.45s-.45-.22-.59-.43L83 290.06l3-1.67z",
    id: "formplay_svg__el8hpcvugncc6",
    className: "formplay_svg__animable",
    style: {
      transformOrigin: "92.37px 299.276px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M127.72 316.74L84 291c-.44-.27-.93-.58-1.06-1.08s.31-1.27.78-1.75a30.11 30.11 0 0123.37-9.17 26.66 26.66 0 0121.11 13.13c4.22 7.53 4.36 17.5-.48 24.65",
    style: {
      transformOrigin: "107.138px 297.866px"
    },
    id: "formplay_svg__el3bk55xv97sh",
    className: "formplay_svg__animable",
    fill: "#fcbd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.32 282.73a2.06 2.06 0 01.57-.08c.38 0 .94-.08 1.66-.08a32.79 32.79 0 016.06.49 35.09 35.09 0 018.63 2.62 35.52 35.52 0 0119.66 23 33.26 33.26 0 011.08 6 12.43 12.43 0 01.07 1.27 2.18 2.18 0 01-.34.95 7.56 7.56 0 00.07-2.2 37.67 37.67 0 00-1.24-5.91 35.71 35.71 0 00-28-25.33 38 38 0 00-6-.64c-1.42-.07-2.22-.05-2.22-.09z",
    style: {
      transformOrigin: "109.185px 299.734px"
    },
    id: "formplay_svg__ela7ysqtbti2w",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.81 299a11.51 11.51 0 01-2.21 1c-1.39.55-3.34 1.25-5.51 1.94s-4.18 1.24-5.63 1.6a10.54 10.54 0 01-2.38.45 12.44 12.44 0 012.28-.81l5.57-1.74 5.55-1.79a11.27 11.27 0 012.33-.65z",
    style: {
      transformOrigin: "113.945px 301.495px"
    },
    id: "formplay_svg__elrr6f1q31wr",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.93 280.46a31.2 31.2 0 01.25 9.77 29.71 29.71 0 01-.26-4.88 30.8 30.8 0 01.01-4.89z",
    style: {
      transformOrigin: "115.139px 285.345px"
    },
    id: "formplay_svg__elg59k92bfffj",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.64 290.47a18.87 18.87 0 013.18-1.12c2-.61 4.75-1.39 7.83-2.13s5.9-1.31 7.94-1.67a19.4 19.4 0 013.34-.45 24.59 24.59 0 01-3.26.81c-2 .45-4.82 1.08-7.9 1.82s-5.84 1.46-7.85 2a23.72 23.72 0 01-3.28.74z",
    style: {
      transformOrigin: "94.785px 287.785px"
    },
    id: "formplay_svg__elarq8r0t3dyh",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.29 320.94c-3.76-2.85-7.73-3.42-12.45-3.23a38 38 0 00-13.62 3.52c-7.37 3.22-14.29 8-18.7 14.71s-5.93 15.65-2.63 23a3.24 3.24 0 001.49 1.81 3.6 3.6 0 002.47-.19c8.38-2.73 16.82-5.49 24.52-9.77s14.72-10.24 18.86-18a15.48 15.48 0 002-6 7.41 7.41 0 00-1.92-5.84",
    style: {
      transformOrigin: "85.6918px 339.281px"
    },
    id: "formplay_svg__elluenn4sth58",
    className: "formplay_svg__animable",
    fill: "#fcbd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.37 320.05a3.57 3.57 0 01-.61.25l-1.75.6-1.28.42c-.46.17-1 .38-1.48.58-1.06.43-2.29.86-3.59 1.49l-2 .94c-.72.33-1.43.73-2.18 1.11-1.52.75-3.06 1.7-4.69 2.67a73.82 73.82 0 00-18.49 16.27c-1.17 1.5-2.31 2.9-3.25 4.31-.47.7-1 1.35-1.38 2l-1.19 1.92c-.79 1.2-1.37 2.37-1.93 3.37-.28.5-.54 1-.77 1.4s-.4.84-.58 1.2l-.82 1.67a2.93 2.93 0 01-.32.57 2.67 2.67 0 01.22-.61l.74-1.71q.24-.57.54-1.23c.21-.45.47-.92.73-1.43.54-1 1.1-2.2 1.87-3.42l1.17-1.95c.41-.67.9-1.34 1.37-2.05.92-1.43 2.06-2.85 3.22-4.37a72.3 72.3 0 0118.56-16.35c1.66-1 3.21-1.91 4.75-2.64.76-.38 1.48-.78 2.2-1.1l2.08-.91c1.32-.61 2.56-1 3.64-1.42.54-.2 1-.39 1.5-.54l1.29-.38 1.79-.51a2.47 2.47 0 01.64-.15z",
    style: {
      transformOrigin: "86.215px 340.435px"
    },
    id: "formplay_svg__el6q1plnlvimc",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 336a87.67 87.67 0 01-9.14 2.95 86.87 86.87 0 01-9.29 2.44 87.67 87.67 0 019.14-2.95A89.84 89.84 0 0180 336z",
    style: {
      transformOrigin: "70.785px 338.695px"
    },
    id: "formplay_svg__ela1nb0r187dt",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.63 356.13a14 14 0 01-.2-2.85c-.05-1.76-.06-4.2 0-6.89s.22-5.11.37-6.87a14.82 14.82 0 01.36-2.83 16.89 16.89 0 010 2.85c-.06 1.93-.13 4.28-.21 6.87s-.13 4.94-.17 6.87a17.18 17.18 0 01-.15 2.85z",
    style: {
      transformOrigin: "79.8044px 346.41px"
    },
    id: "formplay_svg__elph0r0aymky",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.91 347.32c-.15 0-.61-4.94-1-11.05s-.65-11.07-.5-11.08.6 4.93 1 11.05.64 11.07.5 11.08z",
    style: {
      transformOrigin: "96.1586px 336.255px"
    },
    id: "formplay_svg__elst5d2udsg1j",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4 324.71a16.66 16.66 0 012.93-.09c1.8 0 4.3.07 7 .16s5.25.2 7.05.31a15.84 15.84 0 012.92.28 16.66 16.66 0 01-2.93.09c-1.8 0-4.3-.07-7.06-.16s-5.25-.2-7-.31a16.79 16.79 0 01-2.91-.28z",
    style: {
      transformOrigin: "85.35px 325.04px"
    },
    id: "formplay_svg__elrhofl4y7nk8",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.88 384.9a2.23 2.23 0 01-.06-.58c0-.44 0-1-.08-1.68-.07-1.46-.08-3.58 0-6.19s.22-5.73.54-9.17.83-7.21 1.53-11.14 1.6-7.64 2.49-11 1.85-6.32 2.73-8.79 1.63-4.45 2.2-5.8l.67-1.55a4.58 4.58 0 01.26-.53 2.39 2.39 0 01-.16.57c-.15.41-.34.94-.58 1.58-.51 1.37-1.22 3.37-2 5.84s-1.72 5.46-2.61 8.8-1.72 7-2.44 11-1.21 7.67-1.57 11.1-.56 6.52-.65 9.13-.15 4.72-.15 6.17v1.69a2.39 2.39 0 01-.12.55z",
    style: {
      transformOrigin: "121.922px 356.685px"
    },
    id: "formplay_svg__eldrn36g7a3dc",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.19 356.29a12.69 12.69 0 01-1.75 1.91c-1.13 1.13-2.73 2.64-4.57 4.25s-3.54 3-4.8 4a11.61 11.61 0 01-2.13 1.48 13.06 13.06 0 011.89-1.76l4.7-4.08 4.66-4.13a13.22 13.22 0 012-1.67z",
    style: {
      transformOrigin: "112.565px 362.11px"
    },
    id: "formplay_svg__els7mingakr7",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 367.43a20.22 20.22 0 01-1.86-2.57l-4.32-6.3-4.41-6.24a20.31 20.31 0 01-1.76-2.64 18.86 18.86 0 012.06 2.42c1.21 1.54 2.83 3.71 4.54 6.16s3.18 4.73 4.2 6.4a18.67 18.67 0 011.55 2.77z",
    style: {
      transformOrigin: "126.825px 358.555px"
    },
    id: "formplay_svg__elvjy73v5xuz",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.77 332.39c.08.12-4.51 3.22-10.26 6.91S105 345.89 105 345.77s4.52-3.22 10.27-6.91 10.42-6.59 10.5-6.47z",
    style: {
      transformOrigin: "115.386px 339.08px"
    },
    id: "formplay_svg__elkpmvgo4vmuc",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73 346.37a84.72 84.72 0 01-6.95-6.42 84.42 84.42 0 01-6.59-6.8 86.32 86.32 0 016.95 6.43 87.42 87.42 0 016.59 6.79z",
    style: {
      transformOrigin: "131.96px 339.76px"
    },
    id: "formplay_svg__el3as0asa4e8z",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 346.09l3.94-.32a19.49 19.49 0 008-2.44 32.2 32.2 0 013.71-1.87c4.88-1.95 10.32-1.6 15.57-1.87a64.39 64.39 0 0024.76-6.33 2.38 2.38 0 001.08-1c.81-1.47-.7-2.79-2-3.59-6.65-4.09-13.41-8.24-20.95-10.27s-16.09-1.69-22.52 2.74C146 326.35 143.26 337 142 346.09",
    style: {
      transformOrigin: "170.644px 331.648px"
    },
    id: "formplay_svg__elqjzuumwb4fm",
    className: "formplay_svg__animable",
    fill: "#fcbd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.11 331.8a4.3 4.3 0 01-.67-.31l-1.87-1c-1.62-.86-4-2.11-6.91-3.53a64.38 64.38 0 00-10.66-4.1 35.32 35.32 0 00-13.85-1.12 23.75 23.75 0 00-12.63 5.42 28.18 28.18 0 00-6.58 9.24c-1.38 3-2.24 5.47-2.86 7.19-.29.83-.52 1.49-.7 2a3 3 0 01-.28.68 6 6 0 01.18-.71c.15-.51.36-1.18.61-2a63.36 63.36 0 012.72-7.29 27.88 27.88 0 016.59-9.44 24 24 0 0112.88-5.58 35.32 35.32 0 0114 1.18 61.8 61.8 0 0110.72 4.25c2.94 1.46 5.25 2.77 6.85 3.68l1.82 1.06a4.18 4.18 0 01.64.38z",
    style: {
      transformOrigin: "170.605px 333.641px"
    },
    id: "formplay_svg__el1nuq0j571k1",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.63 336.89c-.08.12-5.24-3.22-11.52-7.46s-11.31-7.76-11.23-7.88 5.24 3.21 11.52 7.45 11.31 7.77 11.23 7.89z",
    style: {
      transformOrigin: "178.255px 329.22px"
    },
    id: "formplay_svg__elojqp0d1b06m",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.13 321.27a12.15 12.15 0 01-3.76.68 12.48 12.48 0 01-3.83-.05 26.12 26.12 0 013.79-.39 25.22 25.22 0 013.8-.24z",
    style: {
      transformOrigin: "180.335px 321.671px"
    },
    id: "formplay_svg__elggc6lmdpp3n",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.55 318.33a10.21 10.21 0 01-1.7 2.64 10.74 10.74 0 01-2.14 2.44 10 10 0 011.69-2.64 10.91 10.91 0 012.15-2.44z",
    style: {
      transformOrigin: "159.63px 320.87px"
    },
    id: "formplay_svg__elooz44q3kp7",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.17 339.93a14.91 14.91 0 01-2.48-1.35c-1.49-.9-3.51-2.23-5.66-3.79s-4.05-3-5.41-4.12a15.13 15.13 0 01-2.14-1.84 14.69 14.69 0 012.36 1.54l5.5 4c2.14 1.56 4.11 2.93 5.55 3.91a16.2 16.2 0 012.28 1.65z",
    style: {
      transformOrigin: "158.325px 334.38px"
    },
    id: "formplay_svg__elqojhbwsah4",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.79 362.85c-3.76-1-8.24 2.67-9 6.48s.66 7.71 2.33 11.23c3.71 7.77 8.82 15 15.56 20.35s15.17 8.81 23.79 8.76c-1.59-7.39.42-15.1-.47-22.61a29.4 29.4 0 00-26-25.79c-2.4-.26-5.18-.64-6.14 1.58",
    style: {
      transformOrigin: "159.525px 385.37px"
    },
    id: "formplay_svg__el0jwib1hjz9d5",
    className: "formplay_svg__animable",
    fill: "#fcbd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.45 409.67a2.32 2.32 0 01-.54-.25 8.9 8.9 0 01-1.4-.94 14.64 14.64 0 01-3.72-5c-.6-1.17-1.27-2.43-1.92-3.83l-2-4.47a43.89 43.89 0 00-2.49-4.79 36.44 36.44 0 00-3.42-4.65c-2.58-3-5.34-5.65-7.73-8.15a53.1 53.1 0 01-5.9-7.07 25.46 25.46 0 01-2.88-5.51 15.77 15.77 0 01-.51-1.61 3.9 3.9 0 01-.12-.58c.05 0 .27.77.82 2.12a28.34 28.34 0 003 5.37 56.38 56.38 0 005.94 7c2.41 2.47 5.19 5.08 7.79 8.14a37.07 37.07 0 013.46 4.73 42.12 42.12 0 012.49 4.85c.7 1.57 1.36 3.08 2 4.49s1.28 2.67 1.86 3.84a15.12 15.12 0 003.52 5c1.04.91 1.78 1.26 1.75 1.31z",
    style: {
      transformOrigin: "164.135px 386.245px"
    },
    id: "formplay_svg__elhgnl9wql5mi",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 403.53a11 11 0 01.35-2.53c.29-1.55.78-3.68 1.43-6s1.35-4.39 1.91-5.86a11.1 11.1 0 011-2.34 14 14 0 01-.67 2.46c-.47 1.5-1.11 3.57-1.76 5.88s-1.18 4.41-1.57 5.93a13.1 13.1 0 01-.69 2.46z",
    style: {
      transformOrigin: "163.345px 395.165px"
    },
    id: "formplay_svg__el41osjw6wtwo",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.73 385.4a16.68 16.68 0 01-2.65-.61c-1.62-.43-3.86-1-6.35-1.57s-4.76-1-6.4-1.3a16.92 16.92 0 01-2.66-.59 12.53 12.53 0 012.71.22c1.67.22 4 .6 6.47 1.16s4.74 1.21 6.34 1.72a12 12 0 012.54.97z",
    style: {
      transformOrigin: "170.7px 383.363px"
    },
    id: "formplay_svg__el46a7ms1299y",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 390.67a15.32 15.32 0 01.41-2.93c.33-1.8.86-4.27 1.56-7s1.45-5.11 2-6.84a15.14 15.14 0 011.08-2.75 18.4 18.4 0 01-.73 2.86c-.49 1.76-1.18 4.18-1.88 6.87s-1.29 5.13-1.71 6.9a18.12 18.12 0 01-.73 2.89z",
    style: {
      transformOrigin: "149.525px 380.91px"
    },
    id: "formplay_svg__elp80p7tahmk",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.1 369.59a103 103 0 01-10.49-.84c-5.77-.62-10.45-1.23-10.43-1.37a101.53 101.53 0 0110.49.85c5.78.61 10.45 1.22 10.43 1.36z",
    style: {
      transformOrigin: "160.64px 368.485px"
    },
    id: "formplay_svg__elvnwkhril3",
    className: "formplay_svg__animable",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.66 426.55c0 .15-16.51.26-36.87.26s-36.88-.11-36.88-.26 16.51-.26 36.88-.26 36.87.12 36.87.26z",
    style: {
      transformOrigin: "130.785px 426.55px"
    },
    id: "formplay_svg__el2exnbsfb8sr",
    className: "formplay_svg__animable",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.18 447.8c0 .14-11.13.26-24.85.26s-24.84-.12-24.84-.26 11.12-.26 24.84-.26 24.85.11 24.85.26z",
    style: {
      transformOrigin: "131.335px 447.8px"
    },
    id: "formplay_svg__el74l50govowv",
    className: "formplay_svg__animable",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.74 450.84c0 .14-10.93.26-24.41.26s-24.41-.12-24.41-.26 10.93-.26 24.41-.26 24.41.11 24.41.26z",
    style: {
      transformOrigin: "131.33px 450.84px"
    },
    id: "formplay_svg__elc3y9c1vznx",
    className: "formplay_svg__animable",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.61 445.3c0 .14-11.51.26-25.7.26s-25.7-.12-25.7-.26 11.51-.27 25.7-.27 25.7.12 25.7.27z",
    style: {
      transformOrigin: "130.91px 445.295px"
    },
    id: "formplay_svg__elz45s6k3legj",
    className: "formplay_svg__animable",
    fill: "#455a64"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "formplay_svg__active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "formplay_svg__hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormplay);
export default __webpack_public_path__ + "static/media/formplay.02d5dace98663a12f66204c4c11f8ca3.svg";
export { ForwardRef as ReactComponent };